module.exports = __webpack_public_path__ + "static/media/cross.3c560aaa.svg";